import React from 'react';
import CountDownEntity from '../entities/CountDown/CountDown';
import { observer } from 'mobx-react';

const CountDown = observer(() => {
  const countDown = CountDownEntity.countDown;
  return (
    <div>
      {countDown > 0 ? (
        <div
          style={{
            position: 'fixed',
            left: '50%',
            top: '20%',
            fontSize: '11rem',
            zIndex: 5,
            color: 'brown',
          }}>
          <div>{countDown}</div>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
});

export default CountDown;
